import { useTranslation } from 'react-i18next';
import Icons from '../../../../../../../common/widgets/Icons';
import { resources } from '../../../../../resources/resources';

export default function InfoPanel() {
  const { t: translate } = useTranslation();
  return (
    <>
      <h3>
        {translate(resources.admin.fileImport.editTemplate.instructions.title)}
      </h3>
      <ul>
        <li>
          <span>
            <Icons.Add />
          </span>
          <span>
            {translate(
              resources.admin.fileImport.editTemplate.instructions.add,
            )}
          </span>
        </li>
        <li>
          <span>
            <Icons.EditBig />
          </span>
          <span>
            {translate(
              resources.admin.fileImport.editTemplate.instructions.edit,
            )}
          </span>
        </li>
        <li>
          <span>
            <Icons.Delete />
          </span>
          <span>
            {translate(
              resources.admin.fileImport.editTemplate.instructions.delete,
            )}
          </span>
        </li>
        <li>
          <span>
            <Icons.Drag />
          </span>
          <span>
            {translate(
              resources.admin.fileImport.editTemplate.instructions.changeOrder,
            )}
          </span>
        </li>
      </ul>
    </>
  );
}
